import {useCallback, useEffect, useState} from 'react';
import {postDocumentFeedback} from '../../utils/api/document';
import {nanoid} from 'nanoid';

/**
 * Custom hook for managing document feedback (score)
 * @param {Object} params
 * @param {string} params.docId - Document ID
 * @param {Object} params.feedback - Initial feedback object
 * @param {string} params.userId - Current user ID
 * @returns {Object} {score, handleScoreChange}
 */
export function useDocumentFeedback({docId, feedback, userId}) {
    const [score, setScore] = useState(
        (feedback && Number.isFinite(feedback.score)) ? feedback.score : null
    );

    useEffect(() => {
        setScore((feedback && Number.isFinite(feedback.score)) ? feedback.score : null);
    }, [feedback]);

    const handleScoreChange = useCallback(async (newValue) => {
        setScore(newValue);
        try {
            if (!docId) return;
            if (!Number.isFinite(newValue)) return;
            await postDocumentFeedback(docId, {
                feedbackId: nanoid(),
                userId: userId || 'uuu1',
                score: newValue,
            });
        } catch (e) {
            console.error('Failed to send feedback', e);
        }
    }, [docId, userId]);

    return {score, handleScoreChange};
}
